"use client"

import { PaneListSkeleton } from "@/components/layout/pane-list-skeleton"
import { PageContainer } from "@/components/ui/page-container"
import { useEmployerOrganisationOptional } from "@/context/employer-organisation-context"
import { EmployerOrganisationSettingsRoutes } from "@/components/employer/employer-organisation-settings-routes"

export function EmployerOrganisationSettingsGate() {
  const ctx = useEmployerOrganisationOptional()

  if (!ctx?.enabled) {
    return (
      <PageContainer maxWidth="4xl" className="py-10">
        <p className="text-sm text-muted-foreground">Switch to employer focus to manage organisation settings.</p>
      </PageContainer>
    )
  }

  if (ctx.organisationsLoading) {
    return (
      <PageContainer>
        <PaneListSkeleton count={2} ariaLabel="Loading organisation settings" />
      </PageContainer>
    )
  }

  const slug = ctx.activeOrganisationSlug?.trim() ?? ""

  if (!slug && ctx.organisations.length === 0) {
    return (
      <PageContainer maxWidth="4xl" className="py-10">
        <p className="text-sm text-muted-foreground">Create an organisation to manage settings.</p>
      </PageContainer>
    )
  }

  if (!slug) {
    return (
      <PageContainer maxWidth="4xl" className="py-10">
        <p className="text-sm text-muted-foreground">Choose a workspace from the sidebar switcher.</p>
      </PageContainer>
    )
  }

  return <EmployerOrganisationSettingsRoutes slug={slug} />
}
